import classNames from "classnames";

interface Props {
  isRecording: boolean;
  startRecording: () => void;
  pauseRecording: () => void;
  disabled?: boolean;
  padding?: string;
}

const RecordButton = ({
  isRecording,
  startRecording,
  pauseRecording,
  disabled,
  padding = "20px",
}: Props) => {
  return (
    <i
      className={classNames(
        "bg-primary text-white cursor-pointer mb-2",
        {
          "mdi mdi-microphone": !isRecording,
        },
        { "mdi mdi-pause": isRecording }
      )}
      onClick={
        disabled
          ? undefined
          : () => {
              isRecording ? pauseRecording() : startRecording();
            }
      }
      style={{
        fontSize: 75,
        padding: `0 ${padding}`,
        backgroundColor: "var(--primary)",
        borderRadius: "50%",
      }}
      id={isRecording ? "ripple-animation-play-button" : undefined}
    />
  );
};

export default RecordButton;
